import { __extends } from "tslib";
import React from 'react';
import throttle from 'lodash/throttle';
var THROTTLE_TIMEOUT = 100;
var ElementQueries = /** @class */ (function (_super) {
    __extends(ElementQueries, _super);
    function ElementQueries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveRootRef = function (node) {
            _this.rootRef = node;
            var forwardedRef = _this.props.forwardedRef;
            if (forwardedRef) {
                if (typeof forwardedRef === 'function') {
                    forwardedRef(node);
                }
                else {
                    forwardedRef.current = node;
                }
            }
        };
        _this.getMinWidthAttrValue = function (elementWidth) {
            var minWidth = _this.props.widthBreakpoints.filter(function (width) { return width <= elementWidth; });
            return minWidth.join(' ');
        };
        _this.getMaxWidthAttrValue = function (elementWidth) {
            var maxWidth = _this.props.widthBreakpoints.filter(function (width) { return width >= elementWidth; });
            return maxWidth.join(' ');
        };
        _this.setBreakpoints = throttle(function () {
            return requestAnimationFrame(function () {
                if (!_this.rootRef) {
                    return;
                }
                var sizes = _this.rootRef.getBoundingClientRect();
                _this.rootRef.setAttribute('data-max-width', _this.getMaxWidthAttrValue(sizes.width));
                _this.rootRef.setAttribute('data-min-width', _this.getMinWidthAttrValue(sizes.width));
                _this.props.onSettled && _this.props.onSettled();
            });
        }, THROTTLE_TIMEOUT);
        return _this;
    }
    ElementQueries.prototype.componentDidMount = function () {
        this.setBreakpoints();
        window.addEventListener('resize', this.setBreakpoints);
    };
    ElementQueries.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.setBreakpoints);
    };
    ElementQueries.prototype.render = function () {
        var _a = this.props, id = _a.id, children = _a.children, width = _a.width, className = _a.className;
        return (React.createElement("div", { id: id, ref: this.saveRootRef, "data-min-width": width && this.getMinWidthAttrValue(width), "data-max-width": width && this.getMaxWidthAttrValue(width), className: className }, children));
    };
    return ElementQueries;
}(React.Component));
export default ElementQueries;
//# sourceMappingURL=ElementQueries.js.map